export type OnboardingSection = 'team' | 'schedule' | 'gametime' | 'stats' | 'org' | 'practice';

export interface OnboardingState {
  welcomeComplete: boolean;
  sectionsShown: OnboardingSection[];
  tourComplete: boolean;
  demoGameDone: boolean; // clicked "try demo game" or tracked a real game
}

const DEFAULT: OnboardingState = {
  welcomeComplete: false,
  sectionsShown: [],
  tourComplete: false,
  demoGameDone: false,
};

function key(userId: string, orgId: string) {
  return `sideoutiq_onboarding_${userId}_${orgId}`;
}

export function getOnboardingState(userId: string, orgId: string): OnboardingState {
  try {
    const raw = localStorage.getItem(key(userId, orgId));
    if (!raw) return { ...DEFAULT };
    return { ...DEFAULT, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT };
  }
}

export function saveOnboardingState(userId: string, orgId: string, state: OnboardingState): void {
  localStorage.setItem(key(userId, orgId), JSON.stringify(state));
}

export function markSectionShown(
  userId: string,
  orgId: string,
  section: OnboardingSection,
  current: OnboardingState,
): OnboardingState {
  if (current.sectionsShown.includes(section)) return current;
  const updated = { ...current, sectionsShown: [...current.sectionsShown, section] };
  saveOnboardingState(userId, orgId, updated);
  return updated;
}

export function resetOnboarding(userId: string, orgId: string): void {
  localStorage.removeItem(key(userId, orgId));
}
